import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { ApprovalManagementPageModel } from "../pageModels/ApprovalManagementPageModel";
import { Approval } from "../../models/Approval";
import EasyInput from "../../components/EasyInput/EasyInput";
import Loading from "../../components/Loading/Loading";
import { globalStore } from "../../models/globalStore";
import { VideoPreview } from "../../components/VideoPreview";
import { DateUtil } from "../../utils/DateUtil";

const pageModel = new ApprovalManagementPageModel();

const ApprovalManagementPage: React.FC = observer(() => {
    const [activeTab, setActiveTab] = useState<"unprocessed" | "processing" | "processed">("unprocessed");
    const [videoPreviewUrl, setVideoPreviewUrl] = useState<string | null>(null);

    useEffect(() => {
        globalStore.selectedMenuKey = "approval-management";
        pageModel.loadExamFee();
        pageModel.loadUnprocessed();
        pageModel.loadProcessing();
        pageModel.loadProcessed();
    }, []);

    const handleTabChange = (tab: "unprocessed" | "processing" | "processed") => {
        setActiveTab(tab);
        pageModel.setCurrentTab(tab);
    };

    const renderApprovalList = (approvals: Approval[]) => {
        return (
            <div style={{ padding: "20px" }}>
                {approvals.map(approval => (
                    <div
                        key={approval.id}
                        style={{
                            padding: "20px",
                            border: "1px solid #eee",
                            marginBottom: "15px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between"
                        }}
                    >
                        <div style={{ flex: 1 }}>
                            <div style={{ fontSize: "16px", marginBottom: "8px", fontWeight: 400 }}>
                                {approval.sellerNickname || approval.nickname || "-"}
                            </div>
                            <div style={{ color: "#666", fontSize: "14px", marginBottom: "8px" }}>
                                卖家ID：{approval.sellerId || "-"}
                            </div>
                            <div style={{ color: "#666", fontSize: "14px", marginBottom: "8px" }}>
                                姓名：{approval.realName || "-"}
                            </div>
                            <div style={{ color: "#666", fontSize: "14px", marginBottom: "8px" }}>
                                手机号：{approval.sellerPhone || "-"}
                            </div>
                            <div style={{ color: "#666", fontSize: "14px", marginBottom: "8px" }}>
                                提交时间：{approval.submitTime ? DateUtil.formatDatetime(approval.submitTime) : "-"}
                            </div>
                            {approval.lastRefuseReason && (
                                <div style={{ color: "#ff4d4f", fontSize: "14px" }}>
                                    上次拒绝理由：{approval.lastRefuseReason}
                                </div>
                            )}
                        </div>
                        
                        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                            <button
                                style={{
                                    padding: "6px 12px",
                                    background: "#1890ff",
                                    color: "white",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    fontWeight: 400
                                }}
                                onClick={() => {
                                    if (approval.videoUrl) {
                                        setVideoPreviewUrl(approval.videoUrl);
                                    }
                                }}
                            >
                                查看视频
                            </button>
                            
                            {activeTab === "unprocessed" && (
                                <div style={{ display: "flex", gap: "10px" }}>
                                    <button
                                        style={{
                                            padding: "6px 12px",
                                            background: "#52c41a",
                                            color: "white",
                                            border: "none",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            fontWeight: 400
                                        }}
                                        onClick={() => {
                                            pageModel.setSelectedApproval(approval);
                                            pageModel.setShowConfirmDialog(true);
                                        }}
                                    >
                                        初审通过
                                    </button>
                                    <button
                                        style={{
                                            padding: "6px 12px",
                                            background: "#ff4d4f",
                                            color: "white",
                                            border: "none",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            fontWeight: 400
                                        }}
                                        onClick={() => {
                                            pageModel.setSelectedApproval(approval);
                                            pageModel.setShowRefuseDialog(true);
                                        }}
                                    >
                                        拒绝通过
                                    </button>
                                </div>
                            )}
                            
                            {activeTab === "processing" && (
                                <div style={{ display: "flex", gap: "10px" }}>
                                    <button
                                        style={{
                                            padding: "6px 12px",
                                            background: "#52c41a",
                                            color: "white",
                                            border: "none",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            fontWeight: 400
                                        }}
                                        onClick={() => {
                                            pageModel.setSelectedApproval(approval);
                                            pageModel.setShowConfirmDialog(true);
                                        }}
                                    >
                                        笔试通过
                                    </button>
                                    <button
                                        style={{
                                            padding: "6px 12px",
                                            background: "#ff4d4f",
                                            color: "white",
                                            border: "none",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            fontWeight: 400
                                        }}
                                        onClick={() => {
                                            pageModel.setSelectedApproval(approval);
                                            pageModel.setShowRefuseDialog(true);
                                        }}
                                    >
                                        拒绝通过
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div style={{ height: "100vh", display: "flex", flexDirection: "column", fontWeight: 400 }}>
            <div style={{
                padding: "30px 20px",
                paddingBottom: "0px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
            }}>
                <div>
                    <button
                        style={{
                            padding: "8px 16px",
                            marginRight: "10px",
                            border: "none",
                            background: activeTab === "unprocessed" ? "#1890ff" : "#f5f5f5",
                            color: activeTab === "unprocessed" ? "white" : "#666",
                            cursor: "pointer",
                            fontWeight: 400
                        }}
                        onClick={() => handleTabChange("unprocessed")}
                    >
                        待审核
                    </button>
                    <button
                        style={{
                            padding: "8px 16px",
                            marginRight: "10px",
                            border: "none",
                            background: activeTab === "processing" ? "#1890ff" : "#f5f5f5",
                            color: activeTab === "processing" ? "white" : "#666",
                            cursor: "pointer",
                            fontWeight: 400
                        }}
                        onClick={() => handleTabChange("processing")}
                    >
                        审核中
                    </button>
                    <button
                        style={{
                            padding: "8px 16px",
                            border: "none",
                            background: activeTab === "processed" ? "#1890ff" : "#f5f5f5",
                            color: activeTab === "processed" ? "white" : "#666",
                            cursor: "pointer",
                            fontWeight: 400
                        }}
                        onClick={() => handleTabChange("processed")}
                    >
                        已审核
                    </button>
                </div>
                <button
                    style={{
                        padding: "8px 16px",
                        border: "none",
                        background: "#1890ff",
                        color: "white",
                        cursor: "pointer",
                        fontWeight: 400
                    }}
                    onClick={() => pageModel.setShowExamFeeDialog(true)}
                >
                    设置笔试费用（当前：¥{pageModel.examFee}）
                </button>
            </div>

            <div style={{ flex: 1, overflow: "auto" }}>
                {activeTab === "unprocessed" && renderApprovalList(pageModel.unprocessedApprovals)}
                {activeTab === "processing" && renderApprovalList(pageModel.processingApprovals)}
                {activeTab === "processed" && renderApprovalList(pageModel.processedApprovals)}
            </div>

            {pageModel.showConfirmDialog && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1100
                }}>
                    <div style={{
                        background: "white",
                        width: "400px",
                        padding: "24px",
                        fontWeight: 400
                    }}>
                        <h3 style={{ margin: "0 0 16px 0", fontWeight: 400 }}>
                            {activeTab === "unprocessed" ? "确认初审通过" : "确认笔试通过"}
                        </h3>
                        <p style={{ fontWeight: 400 }}>
                            确认通过该卖家的入驻审核吗？
                        </p>
                        <div style={{ marginTop: "24px", textAlign: "right" }}>
                            <button
                                style={{
                                    marginRight: "10px",
                                    padding: "6px 12px",
                                    background: "#f5f5f5",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 400
                                }}
                                onClick={() => pageModel.setShowConfirmDialog(false)}
                            >
                                取消
                            </button>
                            <button
                                style={{
                                    padding: "6px 12px",
                                    background: "#52c41a",
                                    color: "white",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 400
                                }}
                                onClick={() => pageModel.approveAudit()}
                            >
                                确认
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {pageModel.showRefuseDialog && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1100
                }}>
                    <div style={{
                        background: "white",
                        width: "400px",
                        padding: "24px",
                        fontWeight: 400
                    }}>
                        <h3 style={{ margin: "0 0 16px 0", fontWeight: 400 }}>拒绝通过</h3>
                        <EasyInput
                            label="拒绝原因"
                            type={0}
                            value={pageModel.refuseReason}
                            onChange={(value: string) => pageModel.setRefuseReason(value)}
                            height="100px"
                        />
                        <div style={{ textAlign: "right" }}>
                            <button
                                style={{
                                    marginRight: "10px",
                                    padding: "6px 12px",
                                    background: "#f5f5f5",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 400
                                }}
                                onClick={() => pageModel.setShowRefuseDialog(false)}
                            >
                                取消
                            </button>
                            <button
                                style={{
                                    padding: "6px 12px",
                                    background: "#ff4d4f",
                                    color: "white",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 400
                                }}
                                onClick={() => pageModel.refuseAudit()}
                                disabled={!pageModel.refuseReason}
                            >
                                确认
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {pageModel.showExamFeeDialog && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1100
                }}>
                    <div style={{
                        background: "white",
                        width: "400px",
                        padding: "24px",
                        fontWeight: 400
                    }}>
                        <h3 style={{ margin: "0 0 16px 0", fontWeight: 400 }}>设置笔试费用</h3>
                        <p style={{ color: "#666", fontSize: "14px", marginBottom: "16px" }}>
                            存入系统配置，新提交的入驻申请将使用该费用。设为 0 表示无需缴纳。
                        </p>
                        <EasyInput
                            label="笔试费用（元）"
                            type={0}
                            value={pageModel.examFee}
                            onChange={(value: string) => pageModel.setExamFee(value)}
                            height="40px"
                        />
                        <div style={{ marginTop: "24px", textAlign: "right" }}>
                            <button
                                style={{
                                    marginRight: "10px",
                                    padding: "6px 12px",
                                    background: "#f5f5f5",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 400
                                }}
                                onClick={() => pageModel.setShowExamFeeDialog(false)}
                            >
                                取消
                            </button>
                            <button
                                style={{
                                    padding: "6px 12px",
                                    background: "#1890ff",
                                    color: "white",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 400
                                }}
                                onClick={() => pageModel.saveExamFee()}
                                disabled={pageModel.savingExamFee}
                            >
                                保存
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {pageModel.loading && <Loading />}

            <VideoPreview
                visible={!!videoPreviewUrl}
                src={videoPreviewUrl || ""}
                title="入驻申请视频"
                onClose={() => setVideoPreviewUrl(null)}
            />
        </div>
    );
});

export default ApprovalManagementPage; 